import React, { useState, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import Login from '../pages/Login'
import SearchCard from '../pages/SearchCard'
import { FiSearch, FiUser, FiMenu, FiX } from 'react-icons/fi'
import Menu from './Menu'

export default function Navbar() {
  const { user, logout } = useAuth()
  const nav = useNavigate()
  const [showLogin, setShowLogin] = useState(false)
  const [showSearch, setShowSearch] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  const loginRef = useRef(null)
  const searchRef = useRef(null)

  const handleUserClick = () => {
    if (!user) {
      setShowLogin(true)
    } else if (user.role === 'guest') {
      nav('/guest')
    } else if (user.role === 'host') {
      nav('/host')
    } else if (user.role === 'admin') {
      nav('/admin')
    }
  }

  return (
    <nav className="nav">
      {/* Logo */}
      <div className="nav-left">
        <Link to="/" className="logo">Cuvia</Link>
      </div>

      {/* Iconite si link-uri */}
      <div className="nav-right">
        <div className="nav-icons">
          {/* Search */}
          <div ref={searchRef} className="icon-wrapper">
            <FiSearch
              className="nav-icon"
              onClick={() => setShowSearch(!showSearch)}
            />
            {showSearch && (
              <SearchCard
                anchorRef={searchRef}
                close={() => setShowSearch(false)}
              />
            )}
          </div>

          {/* Login */}
          <div ref={loginRef} className="icon-wrapper">
            <FiUser
              className="nav-icon"
              onClick={handleUserClick} />
            {showLogin && !user && (
              <Login
                close={() => setShowLogin(false)}
                anchorRef={loginRef}
              />
            )}
          </div>

          {/* Hamburger mobil */}
          <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <FiX className="nav-icon" /> : <FiMenu className="nav-icon" />}
          </button>
        </div>

        {/* Link-uri vizibile pe desktop si mobil cand menuOpen = true */}
        <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
          {user ? (
            <>
              {user.role === 'host' && <Link to="/host">Host Dashboard</Link>}
              {user.role === 'guest' && <Link to="/guest">Guest Dashboard</Link>}
              <button
                className="btn-logout"
                onClick={() => {
                  logout()
                  nav('/')
                }}
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/register">Register</Link>
              <Link to="/host">Host</Link>
              <Link to="/guest">Guest</Link>
              <Link to="/payment">Payment</Link>
            </>
          )}
        </div>
      </div>
      {/* Afisam componenta Menu cand menuOpen este true */}
      {menuOpen && <Menu close={() => setMenuOpen(false)} />}
    </nav>
  )
}
